import { pxToRem, type StyleRule } from '@archipro-design/aria';
import type { Coordinates, RGB } from '@modules/paint-picker-new/type';

export const PickerCursor: StyleRule<{
    show: boolean;
    cursorCoordinates: Coordinates;
    currentColor: RGB | null;
}> = ({ show, cursorCoordinates, currentColor }) => ({
    opacity: show ? 1 : 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: `calc(${cursorCoordinates.y}px - ${pxToRem(45)})`,
    left: `calc(${cursorCoordinates.x}px - ${pxToRem(45)})`,
    width: pxToRem(90),
    height: pxToRem(90),
    borderWidth: pxToRem(8),
    borderStyle: 'solid',
    borderRadius: '50%',
    borderColor: currentColor
        ? `rgb(${currentColor.r}, ${currentColor.g}, ${currentColor.b})`
        : '#fff',
});

export const PickerCursorIcon: StyleRule = () => ({
    color: '#fff',
    width: pxToRem(14),
    height: pxToRem(14),
});
